import urlSet from "./urls";
import axios from "axios";

const makeRequest = (url) => {
  axios.get(encodeURI(url)).then((res) => {
    if (window != undefined) {
      window.localStorage.setItem(url, JSON.stringify(res.data));
      return res.data;
    }
  });
};

export const fetchBlogs = async (
  { subcategory, category, search },
  page = 0,
  limit = 6
) => {
  let url = urlSet.get_blogApi.url + "?index=0&minimal=true";
  if (search) url = url + "&limit=100&searchQuery=" + search;
  else if (category && subcategory) {
    url = url + `&limit=6&category=${category}&subcategory=${subcategory}`;
  } else if (category) {
    url = url + `&limit=6&category=${category}`;
  } else {
    url =
      urlSet.get_blogApi.url +
      "?minimal=true&index=" +
      page * limit +
      "&limit=" +
      limit;
  }

  if (window != undefined && window.localStorage.getItem(encodeURI(url))) {
    makeRequest(encodeURI(url));
    return JSON.parse(window.localStorage.getItem(encodeURI(url)));
  } else {
    const res = await axios.get(encodeURI(url));
    if (window != undefined)
      window.localStorage.setItem(encodeURI(url), JSON.stringify(res.data));
    return res.data;
  }
};

export const fetchCategoryBlogs = async (categories) => {
  let data = {};
  if (window != undefined && window.localStorage.getItem("categoryData")) {
    return JSON.parse(window.localStorage.getItem("categoryData"));
  }
  for (let i = 0; i < categories.length; i++) {
    const category = categories[i];

    const blogs = await fetchBlogs({ category: category.name });
    data[category.name] = [...blogs];
  }

  if (window != undefined) {
    window.localStorage.setItem("categoryData", JSON.stringify(data));
  }
  return data;
};

export const fetch = async (url) => {
  if (window != undefined && window.localStorage.getItem(encodeURI(url))) {
    makeRequest(encodeURI(url));
    return JSON.parse(window.localStorage.getItem(encodeURI(url)));
  } else {
    const res = await axios.get(encodeURI(url));
    if (window != undefined)
      window.localStorage.setItem(encodeURI(url), JSON.stringify(res.data));
    return res.data;
  }
};
